import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6ju/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6ju/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres6ju/index', { params: sendParams })
  },
  getDetail (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq
    }
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres6ju/detail/' + params)
  },
  getDetailPopup (popupParams) {
    let searchParams = {
      p_codempid: popupParams.p_codempid,
      p_codtparg: popupParams.p_codtparg
    }
    if (isMock) return generator(mocker.popupTab1())
    const params = searchParams.p_codempid + '/' + searchParams.p_codtparg
    return instance().get(endpoint + '/hres6ju/detailTab1Popup/' + params)
  },
  getDropdowns (dropdownParams) {
    let searchParams = {
      p_codempid: '53100',
      p_dtereq: '23032017',
      p_numseq: '1',
      p_approvno: '1',
      p_staappr: 'Z'
    }
    if (isMock) return generator(mocker.dropdowns())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno + '/' + searchParams.p_staappr
    return instance().get(endpoint + '/hres6ju/dropdowns/' + params)
  },
  getTraining (trainingParams) {
    let searchParams = {
      p_dtemonth: trainingParams.p_dtemonth,
      p_codplan: trainingParams.p_codplan,
      p_codcours: trainingParams.p_codcours
    }
    if (isMock) return generator(mocker.training())
    const params = trainingParams.p_codempid + '/' + trainingParams.p_dteyear
    return instance().get(endpoint + '/hres6ju/popupTrainingTable/' + params, { params: searchParams })
  },
  getNumclseq (detailParams) {
    let searchParams = {
      p_dteyear: detailParams.dteyear,
      p_codcours: detailParams.codcours
    }
    if (isMock) return generator(mocker.numclseq())
    return instance().get(endpoint + '/hres6ju/numclseq', { params: searchParams })
  },
  getCourseDetail (detailParams) {
    let codempid = detailParams.codempid
    let dtereq = detailParams.dtereq.replace(/\//g, '')
    let numseq = detailParams.numseq
    let searchParams = {
      p_dteyear: detailParams.dteyear,
      p_codcours: detailParams.codcours,
      p_numclseq: detailParams.numclseq
    }
    const params = codempid + '/' + dtereq + '/' + numseq
    if (isMock) return generator(mocker.courseDetail())
    return instance().get(endpoint + '/hres6ju/courseDetail/' + params, { params: searchParams })
  },
  getDetailSubmit (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_approvno: detailParams.approvno,
      p_staappr: detailParams.staappr
    }
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno + '/' + searchParams.p_staappr
    if (isMock) return generator(mocker.detailSubmit())
    return instance().get(endpoint + '/hres6ju/detailSubmit/' + params)
  },
  postSendApprove (approveParams) {
    let dtereq = typeof approveParams.dtereq !== 'undefined' ? approveParams.dtereq.replace(/\//g, '') : ''
    let dteappr = typeof approveParams.dteappr !== 'undefined' ? approveParams.dteappr.replace(/\//g, '') : ''
    let dtetrst = typeof approveParams.dtetrst !== 'undefined' ? approveParams.dtetrst.replace(/\//g, '') : ''
    let dtetren = typeof approveParams.dtetren !== 'undefined' ? approveParams.dtetren.replace(/\//g, '') : ''
    let paramJson = {
      '0': {
        p_staappr: approveParams.flgStaappr,
        p_approvno: approveParams.approvno,
        p_chk_appr: approveParams.chk_appr,
        p_numseq: approveParams.numseq,
        p_codempid: approveParams.codempid,
        p_dtereq: dtereq,
        p_codappr: approveParams.codappr,
        p_dteappr: dteappr,
        p_codtparg: approveParams.codtparg,
        p_codcours: approveParams.codcours,
        p_numclseq: approveParams.numclseq,
        p_codplan: approveParams.codplan,
        p_dteyear: approveParams.dteyear,
        p_dtetrst: dtetrst,
        p_dtetren: dtetren,
        p_codinsts: approveParams.codinsts,
        p_codhotel: approveParams.codhotel,
        p_amtbudg: approveParams.amtbudg,
        p_remark: approveParams.remark,
        p_flgwarn: ''
      }
    }
    let sendParams = {
      param_json: JSON.stringify(paramJson),
      remarkApprove: (approveParams.flgStaappr === 'A') ? approveParams.remark : '',
      remarkReject: (approveParams.flgStaappr === 'N') ? approveParams.remark : ''
    }
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres6ju/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6ju/index.js